import { Dispatch, SetStateAction } from "react";

import { TableColumn } from "@/components/Table/Table";
import { SortParams } from "@/types/types";

import {
	renderOrgSelectColumn,
	renderOrgLeadScoringColumn,
	renderOrgNameColumn,
	renderOrgCountryColumn,
	renderOrgIndustryColumn,
	renderOrgEmployeesColumn,
	renderOrgFoundedYearColumn,
	renderOrgCompanyCategoryColumn,
	renderOrgListsColumn,
	renderOrgProspectCountColumn,
	renderOrgWebsiteColumn,
	renderOrgCityColumn,
	renderOrgStateColumn,
	renderOrgProfileTrackerColumn,
} from "../../utils/allColumns";

export interface CompaniesTableColumnsProps {
	handleCopyClick: (value: string) => void;
	ts: (key: string) => string;
	sortingInbox: SortParams;
	setShowEdit: (val: { id: number; name: string }) => void;
	showEdit: { id: number; name: string } | undefined;
	setShowAll: Dispatch<SetStateAction<boolean>>;
	toggleSelectAll: () => void;
	selectAll: boolean;
	selectedItems: number[];
	handleSelectItem: (id: number) => void;
	onAddToTracker: (organizationId: number) => void;
}

export const CompaniesTableColumns = ({
	handleCopyClick,
	ts,
	sortingInbox,
	setShowEdit,
	showEdit,
	setShowAll,
	toggleSelectAll,
	selectAll,
	selectedItems,
	handleSelectItem,
	onAddToTracker,
}: CompaniesTableColumnsProps): TableColumn[] => {
	return [
		renderOrgSelectColumn(setShowAll, toggleSelectAll, selectAll, selectedItems, handleSelectItem),
		renderOrgLeadScoringColumn(ts, sortingInbox),
		renderOrgNameColumn(ts, handleCopyClick, sortingInbox, setShowEdit, showEdit),
		renderOrgProfileTrackerColumn(ts, onAddToTracker),
		renderOrgIndustryColumn(ts, handleCopyClick, sortingInbox),
		renderOrgEmployeesColumn(ts, handleCopyClick, sortingInbox),
		renderOrgCountryColumn(ts, handleCopyClick, sortingInbox),
		renderOrgCityColumn(ts, handleCopyClick, sortingInbox),
		renderOrgStateColumn(ts, handleCopyClick, sortingInbox),
		renderOrgProspectCountColumn(ts, sortingInbox),
		renderOrgFoundedYearColumn(ts, sortingInbox),
		renderOrgCompanyCategoryColumn(ts, sortingInbox),
		renderOrgListsColumn(ts),
	];
};
